import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TrialExpireService {
  blockPortalAccess = signal<boolean>(false);

  setBlockPortalAccess(value: boolean) {
    this.blockPortalAccess.set(value);
  }

  toggleBlockPortalAccess() {
    this.blockPortalAccess.update((val) => {
      return !val;
    });
  }

  getBlockPortalAccess() {
    return this.blockPortalAccess();
  }
}
